<div>
  <div class="card-holder --newBrand">
    <p class="card-holder-label" data-test="labelEmail">E-mail:</p>
    <p class="info-contact-value" data-test="valueEmail">
        {{ infos?.email || '--' }}
    </p>
    <up-ui-copy-button [newBrand]=true [id]="'btnCopyEmail'" [label]="infos?.email"></up-ui-copy-button>
  </div>
  <div class="card-holder --newBrand">
    <p class="card-holder-label" data-test="labelPhone">Celular:</p>
    <p class="info-contact-value" data-test="valuePhone">
        {{ infos?.phone ||'--' }}
    </p>
    <up-ui-copy-button [newBrand]=true [id]="'btnCopyPhone'" [label]="infos?.phone"></up-ui-copy-button>
  </div>
</div>
